import * as Sentry from '@sentry/nuxt'

export default defineNuxtPlugin(() => {
  const customScripts = document.querySelectorAll(
    'script[type="text/delayed-javascript"]',
  )
  customScripts.forEach((script, index) => {
    const content = script.innerHTML
    if (!content || content.trim().length === 0) {
      return
    }
    try {
      eval(content)
    } catch (e) {
      const context = {
        index,
        contentLength: content.length,
        preview: content.slice(0, 100),
        tail: content.slice(-50),
      }
      console.error('[delayedJs] Failed to execute delayed script:', {
        ...context,
        error: e,
      })
      Sentry.captureException(e, {
        tags: { source: 'delayedJs' },
        extra: context,
      })
    }
  })
})
